export default "__VITE_ASSET__BzbPPSoz__"